import apiClient from "./index";

export const menuFindAll = () => {
  return apiClient.get(`/admin/menu/findAll.json`);
};

export const menuSave = (data) => {
  return apiClient.post(`/admin/menu/saveProc.json`, data);
};

export const menuFindByMenu = (data) => {
  return apiClient.post(`/admin/menu/findByMenu.json`, data);
};

// 메뉴 단건 조회 — 메뉴 만족도 설문 사용여부
export const menuFindMenuDgstfn = (data) => {
  return apiClient.post(`/sys/menu/findMenuDgstfn.json`, data);
};

export const menuUpdate = (data) => {
  return apiClient.post(`/admin/menu/updateProc.json`, data);
};

export const updateListProc = data => {
  return apiClient.post(`/admin/menu/updateListProc.json`, data);
}

export const menuDelete = (data) => {
  return apiClient.post(`/admin/menu/deleteProc.json`, data);
};

export const findBySysMenu = (menu) => {
  return apiClient.post(`/sys/menu/findByMenu.json`, menu);
};
